(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ConfigOnuController', ConfigOnuController);

    ConfigOnuController.$inject = ['$scope', '$rootScope', '$filter', '$timeout', '$uibModalInstance', '$q', 'OnuService', 'OltService', 'onuItem', 'isOnu'];

    function ConfigOnuController($scope, $rootScope, $filter, $timeout, $uibModalInstance, $q, OnuService, OltService, onuItem, isOnu) {

        var vm = this;

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Model
        vm.data = {};

        // Form Actions
        vm.close = close;
        vm.saveSettingsWifi = saveSettingsWifi;

        vm.setSecurityAuth = setSecurityAuth;
        vm.checkSsidInvalid = checkSsidInvalid;
        vm.setSsid = setSsid;
        vm.getSecurityEncryptList = getSecurityEncryptList;

        var encryptOptionsList = [];
        var securityList = [];
        var securityOptionsList = []

        // Settings Slider modal WiFi
        vm.slider = {
            options: {
                floor: 20,
                ceil: 100,
                step: 20,
                hideLimitLabels: true,
                translate: function (value) {
                    return value + '%';
                },
                showSelectionBar: true
            }
        }

        initialize();

        function initialize() {

            vm.data = {
                ssidActive: 0,
                bandwidth: '',
                channel: '',
                sideband: '',
                power: 20,
                ssids: [
                    {
                        ssid: 1,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 2,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 3,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 4,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    }]
            };

            // Comboboxes content
            vm.bandwidthList = ['20', '40'];
            vm.channelList = ['Auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
            vm.sidebandList = [{label: 'upper', value: 'UPPER'}, {label: 'lower', value: 'LOWER'}];
            vm.securityAuthList = [];
            securityOptionsList = [
                {label: 'mixedWpa2Wpa', value: 'MIXED_WPA2_WPA'},
                {label: 'open', value: 'OPEN'},
                {label: 'shared', value: 'SHARED'}
            ];
            securityList = [
                {label: 'wpa2', value: 'WPA2'},
                {label: 'wpa2Psk', value: 'WPA2_PSK'},
                {label: 'mixedWpa2Psk', value: 'MIXED_WPA2_WPA_PSK'},
                {label: 'wpa', value: 'WPA'},
                {label: 'wpaPsk', value: 'WPA_PSK'},
                {label: 'auth', value: 'AUTH_802_1X'}
            ];
            encryptOptionsList = {
                MIXED_WPA2_WPA: [
                    {label: 'AES', value: 'AES'},
                    {label: 'AES/TKIP', value: 'TKIP_AES'}
                ],
                OPEN: [
                    {label: '', value: null},
                    {label: 'WEP', value: 'WEP'}
                ],
                SHARED: [
                    {label: 'WEP', value: 'WEP'}
                ],
                DEFAULT: [
                    {label: 'AES', value: 'AES'},
                    {label: 'AES/TKIP', value: 'TKIP_AES'},
                    {label: 'WEP', value: 'WEP'}
                ]
            };

            $rootScope.$emit('onuConfigLoaded');

            if (isOnu) {
                checkGtpProgress(onuItem).then(function () {
                    getSettings(onuItem.id);
                }).catch(function () {
                    vm.close();
                });
            }

        }
        var clearListener = $rootScope.$on('bridgeClosed', function () {
            checkGtpProgress(onuItem).then(function () {
                getSettings(onuItem.id);
            }).catch(function () {
                vm.close();
            });
        });
        $scope.$on('$destroy', clearListener);

        function setSsid() {
            var securityAuth = vm.data.ssids[vm.data.ssidActive].securityAuth;
            var list = angular.copy(securityOptionsList);
            if (securityAuth) {
                var listItem = $filter('filter')(securityList, {value: securityAuth.value}, true);
                if (listItem.length) {
                    list.unshift(securityAuth);
                }
            }
            vm.securityAuthList = list;
        }

        function getSecurityEncryptList() {
            return encryptOptionsList[vm.data.ssids[vm.data.ssidActive].securityAuth.value] || encryptOptionsList.DEFAULT;
        }

        function setSecurityAuth(selectedAuth) {
            if (selectedAuth.value == 'SHARED') {
                vm.data.ssids[vm.data.ssidActive].securityEncrypt = {label: 'WEP', value: 'WEP'};
            } else {
                vm.data.ssids[vm.data.ssidActive].securityEncrypt = '';
            }
        }

        function checkSsidInvalid(index) {
            var invalid = false;
            angular.forEach(vm.data.ssids[index], function (item, key) {
                if (!(key == 'securityEncrypt' && vm.data.ssids[index].securityAuth.value == 'OPEN')) {
                    if (item === '' || angular.isUndefined(item)) {
                        invalid = true;
                    }
                }
            });
            return vm.formSettingsWifi.$submitted && invalid;
        }

        // Actions methods
        function getSettings(id) {
            vm.requestRunning = true;
            vm.slider.options.disabled = true;
            OnuService.getSettingsWifi(id).then(successWifiSettings).catch(errorWifiSettings);
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function saveSettingsWifi() {
            checkGtp(onuItem).then(function (result) {
                if (result) {
                    var ssidValid = true;
                    vm.data.ssids.forEach(function (item, index) {
                        if (checkSsidInvalid(index)) {
                            ssidValid = false;
                        }
                    });
                    if (vm.formSettingsWifi.$valid && ssidValid && !vm.requestRunning) {
                        vm.requestRunning = true;
                        var data = {
                            onuId: vm.data.onuId,
                            bandwidth: vm.data.bandwidth,
                            channel: vm.data.channel,
                            sideband: vm.data.sideband.value,
                            power: vm.data.power,
                            ssids: vm.data.ssids.map(function (item) {
                                var itemSend = {
                                    ssid: item.ssid,
                                    enable: item.enable
                                }
                                if (item.name) {
                                    itemSend.name = item.name
                                }
                                if (item.securityAuth) {
                                    itemSend.securityAuth = item.securityAuth.value
                                }
                                if (item.securityEncrypt && item.securityEncrypt.value) {
                                    itemSend.securityEncrypt = item.securityEncrypt.value;
                                }
                                if (item.password) {
                                    itemSend.password = item.password
                                }
                                return itemSend;
                            })
                        };
                        OnuService.updateSettingsWifi(data).then(successSaveWifi).catch(errorSaveWifi);
                    }
                }
            });
        }

        // Requests Callbacks
        function successWifiSettings(data) {
            vm.requestRunning = false;
            vm.slider.options.disabled = false;
            vm.data = data;
            vm.data.bandwidth = data.bandwidth.toString();
            vm.data.sideband = $filter('filter')(vm.sidebandList, {value: vm.data.sideband}, true)[0];
            vm.data.ssids = data.ssids.map(function (ssid) {
                if (ssid.securityAuth) {
                    var security = ssid.securityAuth;
                    ssid.securityAuth = $filter('filter')(securityOptionsList, {value: ssid.securityAuth}, true)[0];
                    if (!ssid.securityAuth) {
                        ssid.securityAuth = $filter('filter')(securityList, {value: security}, true)[0];
                    }
                    if (ssid.securityEncrypt) {
                        ssid.securityEncrypt = $filter('filter')(encryptOptionsList[ssid.securityAuth.value] || encryptOptionsList.DEFAULT, {value: ssid.securityEncrypt}, true)[0];
                    }
                }
                return ssid;
            });
            vm.data.ssidActive = 0;
            setSsid(0);
            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            });
        }

        function errorWifiSettings(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'getConfig');
            close();
        }

        function successSaveWifi() {
            vm.requestRunning = false;
            OnuService.successModalConstructor('configWifi', true);
        }

        function errorSaveWifi(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'configWifi');
        }

        function checkGtpProgress(onuItem) {

            return OltService.getOlt(onuItem.oltId)
                    .then(function (data) {

                        if (!data.gtpCpeMgrId) {
                            var modalInstance = OltService.gtpCpeMgrModalConstructor(data.id, $scope, true);
                            return modalInstance.result;
                        } else {
                            return $q.resolve()
                        }

                    });

        }

        function checkGtp(item) {
            var deferred = $q.defer();
            OltService.getOlt(item.oltId)
                    .then(function (data) {
                        if (!data.gtpCpeMgrId) {
                            OltService.gtpCpeMgrModalConstructor(item.oltId, $scope, true);
                            deferred.resolve(false);
                        }
                        deferred.resolve(true);
                    });
            return deferred.promise;
        }
    }
})();